<template>
  <div>
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <b-form-select v-model="controlValue" :options="[]"></b-form-select>
    </b-form-group>
    <div v-if="showType == 'properties'">
      <document-picker-v1-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="showType == 'form-submitter'"
      :description="
        superComputeFormSubmitterValue({
          elementId: this.id,
          property: 'description',
          value: properties.description,
          defaultValue: '',
          form: this.form
        })
      "
      :label="
        superComputeFormSubmitterValue({
          elementId: this.id,
          property: 'label',
          value: properties.label,
          defaultValue: '',
          form: this.form
        })
      "
      :style="properties.style"
      :hidden="computedHidden"
    >
      <v-select
        style="font-size: 14px"
        v-model="controlValue"
        :options="formattedFormOptions"
        :clearable="false"
      ></v-select>
    </b-form-group>
    <b-form-group
      v-if="showType == 'form-viewer'"
      :label="
        superComputeFormSubmitterValue({
          elementId: this.id,
          property: 'label',
          value: properties.label,
          defaultValue: '',
          form: this.form
        })
      "
    >
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import formSubmitterServer from "../../../../server/formSubmitter";
import { formatDate } from "../../../../helpers/date";
import DocumentPickerV1Properties from "./DocumentPickerV1Properties.vue";
import { formatUser } from "../../../../helpers/user";

export default {
  name: "DocumentPickerV1",
  components: { DocumentPickerV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId"],
  data() {
    return {
      formOptions: [],
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {}
    };
  },
  async mounted() {
    if (this.showType == "form-viewer" || this.showType == "form-submitter")
      await this.getFormSubmitsOptions();

    if (
      !this.getFormSubmitterComponentValue(this.id) &&
      this.showType == "form-viewer"
    ) {
      let computedControlValue = this.properties.value
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: "value",
            value: this.properties.value,
            defaultValue: "",
            form: this.form
          })
        : "";
      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: computedControlValue
      });
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", [
      "setFormSubmitterComponentValue",
      "setFormSubmitterComponentMetadata"
    ]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    async getFormSubmitsOptions() {
      let submits = [];
      if (this.properties.formId) {
        submits = await formSubmitterServer.query(
          this.properties.formId,
          this.client.id,
          this.client.episodeOfCare.id
        );
      }

      this.formOptions = submits.map(submit => ({
        value: submit.id,
        text: `${formatDate(submit.createdAt)} by ${
          submit.createdBy ? formatUser(submit.createdBy) : "-"
        }`
      }));
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          Options: this.formOptions
        }
      });
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
        ${this.controlValue ? this.controlValue.label : ""}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      client: state => state.form.client
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue",
      "superComputeFormSubmitterValue",
      "computeFormSubmitterValue"
    ]),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    controlValue: {
      get() {
        let value = null;
        if (this.results) value = JSON.stringify(this.results[this.id]);
        else
          value = JSON.stringify(this.getFormSubmitterComponentValue(this.id));
        const valueObj = this.formattedFormOptions.find(opt => {
          if (value && opt.value) {
            return JSON.parse(value).id == opt.value;
          }
          return false;
        });
        return valueObj;
      },
      async set(newControlValue) {
        if (newControlValue && this.controlValue != newControlValue.value) {
          const parsedControlValue = await formSubmitterServer.get(newControlValue.value);
          const filteredControlValue = {
            id: parsedControlValue.id,
            status: parsedControlValue.status,
            versionId: parsedControlValue.versionId,
            createdAt: parsedControlValue.createdAt,
            createdBy: {
              id: parsedControlValue.createdBy.id,
              fullName: this.formatUser(parsedControlValue.createdBy),
              credentials: parsedControlValue.createdBy.credentials
            },
            mode: parsedControlValue.mode,
            results: parsedControlValue.results,
            score: parsedControlValue.score,
            effectiveDate: parsedControlValue.effectiveDate
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: filteredControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: filteredControlValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                filteredControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    formattedFormOptions() {
      return this.formOptions.map(opt => ({
        value: opt.value,
        label: opt.text
      }));
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'hidden',
            value: this.properties.hidden,
            defaultValue: false,
            form: this.form
          })
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
